/*!
 *
 * Copyright 2019 Dmitry Chuba
 */

jQuery(function ($) {
  'use strict';
  $('#videoPopup')
    .on('show.bs.modal', function (event) {
        const attr   = $(event.relatedTarget).data('href');

        $(this).find('#embed-content').html(attr.embed);
        $(this).find('#embed-content iframe').css('width', '100%');
        $(this).find('#embed-content iframe').css('min-height', '360px');
    })
    .on('hide.bs.modal', function () {
        $(this).find('#embed-content').html('');
    });
  $('#adminPodcastPopup')
    .on('show.bs.modal', function (event) {
        const attr   = $(event.relatedTarget).data('href');

        $(this).find('#embed-content').html(attr.embed);
        $(this).find('#embed-content iframe').css('width', '100%');
    })
    .on('hide.bs.modal', function () {
        $(this).find('#embed-content').html('');
    });

});
